import { render, staticRenderFns } from "./valuation.vue?vue&type=template&id=61a95602&scoped=true"
import script from "./valuation.vue?vue&type=script&lang=js"
export * from "./valuation.vue?vue&type=script&lang=js"
import style0 from "./valuation.vue?vue&type=style&index=0&id=61a95602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a95602",
  null
  
)

export default component.exports